const SvgIcon = ({ name, prefix = 'icon', color, ...props }: any) => {
  const symbolId = `#${prefix}-${name}`;

  return (
    <svg className={`nova-svg cls-${prefix}-${name} nova-option-svg`} {...props} aria-hidden="true">
      <use href={symbolId} fill={color} />
    </svg>
  );
};

export default SvgIcon;
